/* 🤖 this file was generated by svg-to-ts */
export const matIconNoMeetingRoom: {
  name: 'no-meeting-room';
  data: string;
} = {
  name: 'no-meeting-room',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 5v3.88l2 2V6h3v7.88l2 2V4h-5V3H6.12l2 2zM2.41 2.13 1 3.54l4 4V19H3v2h11v-4.46L20.46 23l1.41-1.41L2.41 2.13zM12 19H7V9.54l5 5V19z"/></svg>`
};
